import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from "rxjs";
import {HTTP_PARAMS_CONSTANTS} from '../constants/http/http-params.constants';
import {AuthenticationService} from '../../shared/services/authentication.service';
import { environment } from "../../../environments/environment";

@Injectable()
export class OnHttpRequestInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService
  ) {
  }

  private environment = environment;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedRequest = request;

    if (request.url.startsWith(this.environment.apiBaseUrl)) {
      clonedRequest = this.authenticationService.addInterceptRequestHeaders(request);
    }

    return next.handle(clonedRequest);
  }
}
